'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

exports.default = createGetFormAsyncErrors;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormAsyncErrors.js
// module id = 1882
// module chunks = 0